import React from 'react'
import styled from 'styled-components'

import { pluralizeValues } from '../util'

function formatStats(stats) {
  return pluralizeValues(stats).join(', ')
}

const PublicStats = styled.span`
  color: #666;
`

export default function DomainStats({ stats, publicStats }) {
  const publicNode =
    publicStats != null ? (
      <PublicStats>({formatStats(publicStats)})</PublicStats>
    ) : null

  return (
    <p>
      {formatStats(stats)} {publicNode}
    </p>
  )
}
